/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AllocationAssistanceModal_project = {
    readonly id: string;
    readonly name: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PredictedEndDateModalStatsSection_project">;
    readonly " $refType": "AllocationAssistanceModal_project";
};
export type AllocationAssistanceModal_project$data = AllocationAssistanceModal_project;
export type AllocationAssistanceModal_project$key = {
    readonly " $data"?: AllocationAssistanceModal_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AllocationAssistanceModal_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AllocationAssistanceModal_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PredictedEndDateModalStatsSection_project"
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = 'ccd989af222d51ebce06206eb2d684a1';
export default node;
